import type PlayClient from '@empathybroker/tsclient-play'
import type { AccessTokenProvider } from '@empathyco/playboard-core-domain'
import type { InstancesProvider } from './interfaces'
import { interfaces } from 'inversify'
import { TYPES } from '../config/inversify.types'
import Context = interfaces.Context

export function getInstancesFromPlayProvider({ container }: Context): InstancesProvider {
  return async () => {
    const playClient = container.get<() => PlayClient>(TYPES.PlayClient)()
    const token = await container.get<AccessTokenProvider>(TYPES.AccessTokenProvider)()
    const { data } = await playClient.listInstances(token)

    return data?.items ?? []
  }
}
